import { getLogger } from '@logtape/logtape';

const log = getLogger(['platform', 'coordinates-store']);

function createCoordinatesStore() {
	let coordinates = $state('');
	let justCopied = $state(false);
	let showCoordinates = $state(false);
	let timer: ReturnType<typeof setTimeout> | undefined;

	return {
		get coordinates() {
			return coordinates;
		},
		get justCopied() {
			return justCopied;
		},
		get showCoordinates() {
			return showCoordinates;
		},

		setCoordinates(coords: string) {
			coordinates = coords;
			showCoordinates = true;
		},
		show() {
			showCoordinates = true;
		},
		hide() {
			showCoordinates = false;
		},

		/**
		 * Write coordinates to the clipboard, set justCopied=true, then reset after 1 s.
		 * Mirrors the async thunk in coordinatesSlice.ts (pending → 1 s delay → fulfilled/rejected).
		 */
		async copyCoordinates(coords: string) {
			try {
				await navigator.clipboard.writeText(coords);
			} catch {
				log.error('Writing to clipboard disallowed');
			}
			if (timer !== undefined) clearTimeout(timer);
			justCopied = true;
			timer = setTimeout(() => {
				justCopied = false;
				timer = undefined;
			}, 1000);
		}
	};
}

export const coordinatesStore = createCoordinatesStore();
